export default function AboutUs() {
  return (
    <section id="sobre-nosotros" className="py-20 px-6 bg-sand">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-[2fr_3fr] gap-12 items-center">
          {/* Image */}
          <div className="rounded-2xl overflow-hidden max-w-xs mx-auto md:mx-0">
            <img
              src="https://storage.readdy-site.link/project_files/50551f36-9f7f-4435-8b77-175c3ce034c1/e59c5123-ca2e-4b50-a3cb-a588849b9072_F13D9DD7-B4FD-48F1-9E9E-7B2FA3EC46FB.jpg?v=eb4c9ee0819070140e0fb5bfd2418e7f"
              alt="Laura Soto Shop"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="space-y-6">
            {/* Logo */}
            <div className="flex items-center justify-center md:justify-start mb-6">
              <img
                src="https://static.readdy.ai/image/087f89222492156c346a64d6145fdd91/7c905194fb1686b14af2d930777c0b54.jpeg"
                alt="LauraSoto_Shop Logo"
                className="h-16 w-auto"
                loading="lazy"
              />
            </div>

            <h2 className="font-serif text-3xl md:text-4xl font-bold text-charcoal">
              Nuestra Historia
            </h2>
            <div className="w-12 h-0.5 bg-gold" />

            <div className="space-y-4 font-sans text-lg text-gray-medium leading-relaxed">
              <p>
                <strong className="text-charcoal">Laura Soto Shop</strong> es una boutique
                dedicada a ofrecer{' '}
                <strong>ropa femenina exclusiva</strong> y{' '}
                <strong>fragancias elegantes</strong> que resaltan el estilo, la seguridad
                y la personalidad de todos nuestros clientes.
              </p>
              <p>
                Nuestro objetivo es brindar{' '}
                <strong>productos de calidad</strong> que hagan sentir únicos y seguros a
                nuestros clientes. Cada pieza en nuestra colección ha sido cuidadosamente
                seleccionada para reflejar elegancia, sofisticación y autenticidad.
              </p>
              <p>
                En <strong>Laura Soto Shop</strong>, creemos que la moda y las fragancias
                son expresiones de identidad. Por eso, nos esforzamos por ofrecer una
                experiencia de compra personalizada donde cada cliente encuentre lo que lo
                hace sentir especial.
              </p>
            </div>

            <div className="pt-4">
              <div className="w-32 h-px bg-gold/30" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
